import Component from "./wrapper"
import Header from "./header"

export default {
  Component,
  Header,
}
